namespace $.$$ {

	export class $shm_ba_file_store_list extends $.$shm_ba_file_store_list {

		files() {
			return this.$.$shm_ba_file_store.files()
		}

		files_summary() {
			const files = this.files()
			const bytes = files.reduce( ( sum, file )=> sum + Math.max( 0, Number( file.size ) || 0 ), 0 )
			const count = files.length
			const mod10 = count % 10
			const mod100 = count % 100
			const unit = mod10 === 1 && mod100 !== 11 ? 'файл' : mod10 >= 2 && mod10 <= 4 && ( mod100 < 12 || mod100 > 14 ) ? 'файла' : 'файлов'
			return `${ count.toLocaleString( 'ru-RU' ) } ${ unit } · ${ this.file_size( bytes ) }`
		}

		file_rows() {
			const rows = this.filtered_files().map( file => this.File_row( file.key ) )
			return rows.length ? rows : [ this.Empty() ]
		}

		filtered_files() {
			const query = this.search().trim().toLowerCase()
			if( !query ) return this.files()

			return this.files().filter( file => {
				return [
					file.name,
					file.app_id,
					file.key,
					this.dashboard_title( file.app_id ),
				].some( value => value.toLowerCase().includes( query ) )
			} )
		}

		file( key: string ) {
			return this.files().find( file => file.key === key ) ?? null
		}

		file_title( key: string ) {
			return this.file( key )?.name ?? key
		}

		file_meta( key: string ) {
			const file = this.file( key )
			if( !file ) return ''

			const dashboard = this.dashboard_title( file.app_id )
			const size = this.file_size( file.size )
			return `${ dashboard } · ${ size }`
		}

		dashboard_title( app_id: string ) {
			if( app_id === 'wordstat' ) return 'Wordstat'
			if( app_id === 'default' ) return 'Default'
			const record = this.$.$shm_ba_dashboard_model.records().find( record => record.id === app_id )
			return String( record?.title ?? app_id )
		}

		file_size( bytes: number ) {
			if( bytes < 1024 ) return `${ bytes } Б`
			const kb = bytes / 1024
			if( kb < 1024 ) return `${ kb.toFixed( 1 ) } КБ`
			const mb = kb / 1024
			if( mb < 1024 ) return `${ mb.toFixed( 1 ) } МБ`
			return `${ ( mb / 1024 ).toFixed( 1 ) } ГБ`
		}

		@ $mol_action
		file_delete( key: string, next?: Event ) {
			if( next === undefined ) return null
			this.file_delete_showed( key, false )
			$mol_wire_async( this.$.$shm_ba_file_store ).delete_async( key ).catch( error => {
				if( !$mol_promise_like( error ) ) console.error( error )
			} )
			return next
		}

		@ $mol_mem_key
		file_delete_outside_listener( key: string ) {
			if( !this.file_delete_showed( key ) ) return null
			return new this.$.$shm_listener(
				'pointerdown',
				event => this.file_delete_outside( key, event ),
				this.$.$mol_dom_context.document,
				{ passive: true },
			)
		}

		file_delete_outside( key: string, event?: PointerEvent ) {
			const target = event?.target
			if( !( target instanceof this.$.$mol_dom_context.Node ) ) return event ?? null
			if( this.File_delete( key ).dom_node().contains( target ) ) return event ?? null
			this.file_delete_showed( key, false )
			return event ?? null
		}

		file_delete_cancel( key: string, next?: Event ) {
			if( next === undefined ) return null
			this.file_delete_showed( key, false )
			return next
		}

		@ $mol_mem
		delete_all_showed( next?: boolean ) {
			return next ?? false
		}

		@ $mol_action
		delete_all( next?: Event ) {
			if( next === undefined ) return null
			this.delete_all_showed( false )
			$mol_wire_async( this.$.$shm_ba_file_store ).delete_all_async().catch( error => {
				if( !$mol_promise_like( error ) ) console.error( error )
			} )
			return next
		}

		@ $mol_mem
		delete_all_outside_listener() {
			if( !this.delete_all_showed() ) return null
			return new this.$.$shm_listener(
				'pointerdown',
				event => this.delete_all_outside( event ),
				this.$.$mol_dom_context.document,
				{ passive: true },
			)
		}

		delete_all_outside( event?: PointerEvent ) {
			const target = event?.target
			if( !( target instanceof this.$.$mol_dom_context.Node ) ) return event ?? null
			if( this.Delete_all().dom_node().contains( target ) ) return event ?? null
			this.delete_all_showed( false )
			return event ?? null
		}

		delete_all_cancel( next?: Event ) {
			if( next === undefined ) return null
			this.delete_all_showed( false )
			return next
		}

		empty_message() {
			return this.search().trim() ? 'Файлы не найдены' : 'Локальных файлов нет'
		}

	}

}
